import { any, string } from 'prop-types';
import React from 'react';
// import PropTypes from 'prop-types';
import SelectBox from '../../SelectBox';
import WizardInput from '../Input';

interface CategoryEntity {
    id: string;
    [key: string]: any;
}
interface SubjectSelectorPropInterface {
    subjects: Array<{ Name: string; category: string; [key: string]: any }>;
    category: CategoryEntity;
    disabled: boolean;
    value: string;
    name: string;
    t: (key: string) => any;
    onChange: () => any;
    locale: string;
}

const SubjectSelector: React.FC<SubjectSelectorPropInterface> = ({
    subjects,
    onChange,
    name,
    value,
    disabled,
    t,
    category,
    locale,
}) => (
    <WizardInput
        title={t('course.create.wizard.step2_subject_title')}
        hint={t('wizard.hint.subject')}
    >
        <SelectBox
            disabled={disabled}
            value={value || ''}
            label={t('subject')}
            name={name}
            onChange={onChange}
            filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder={t('course.edit.subject.placeholder')}
            options={
                category &&
                subjects
                    .filter(ct => ct.category && ct.category === category.id)
                    .map(option => ({
                        id: option[`Name_${locale}`] || option.Name,
                        value: option[`Name_${locale}`] || option.Name,
                    }))
            }
        />
    </WizardInput>
);

export default SubjectSelector;
